import { useMemo } from 'react';
import { TranscriptMonologueListProps } from '../types';
import { SpeakerAvatar } from './SpeakerAvatar';
import { mapSpeakersToInfo } from '../utils';

export function TranscriptMonologueList({ monologues, speakers }: TranscriptMonologueListProps) {
  const speakerMap = useMemo(() => {
    const allWords = monologues.flatMap(m => m.words);
    return mapSpeakersToInfo(allWords, speakers);
  }, [monologues, speakers]);

  return (
    <div
      className="h-[350px] overflow-y-auto"
      style={{
        scrollbarWidth: 'thin',
        scrollbarColor: 'transparent transparent'
      }}
    >
      <div className="space-y-4">
        {monologues.map((monologue, index) => {
          const speaker = speakerMap[monologue.speakerLabel] || {
            name: monologue.speakerLabel,
            bgColor: 'bg-slate-600'
          };

          return (
            <div key={`${monologue.speakerLabel}-${index}`} className="flex gap-3">
              <div className="shrink-0">
                <SpeakerAvatar speaker={speaker} />
              </div>
              <div className="flex-1 rounded-[10px] border border-slate-200">
                <p className="whitespace-pre-wrap break-words p-3 text-sm leading-relaxed text-slate-800">
                  {monologue.text}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
